
  var _styles = {
  "landmark-detail-modal__wrapper": {
    "width": "10rem",
    "height": "14.29333rem",
    "flexDirection": "column",
    "justifyContent": "flex-start",
    "alignItems": "flex-start",
    "position": "relative"
  },
  "landmark-detail-modal__close-button": {
    "position": "absolute",
    "zIndex": 1,
    "right": "0.48rem",
    "top": 0
  },
  "landmark-detail-modal__close-button-img": {
    "width": "0.64rem",
    "height": "0.64rem"
  },
  "landmark-detail-modal__content-wrapper": {
    "marginTop": "0.96rem",
    "height": "16rem",
    "flexDirection": "column",
    "justifyContent": "flex-start",
    "alignItems": "flex-start",
    "position": "relative",
    "backgroundColor": "rgb(255,255,255)",
    "borderTopLeftRadius": "0.48rem",
    "borderTopRightRadius": "0.48rem"
  },
  "landmark-detail-modal__header-wrapper": {
    "width": "10rem",
    "height": "2.82667rem",
    "paddingTop": 0,
    "paddingRight": "0.32rem",
    "paddingBottom": 0,
    "paddingLeft": "0.32rem",
    "marginTop": "0.42667rem",
    "flexDirection": "row",
    "justifyContent": "flex-start",
    "alignItems": "flex-start"
  },
  "landmark-detail-modal__scroll-view-outer-wrapper": {
    "flex": 1
  },
  "landmark-detail-modal__scroll-content-wrapper": {
    "width": "10rem",
    "flexDirection": "column",
    "justifyContent": "flex-start",
    "alignItems": "flex-start"
  },
  "landmark-detail-modal__footer": {
    "width": "10rem",
    "height": "4rem"
  },
  "landmark-detail-modal__header-img": {
    "width": "1.62667rem",
    "height": "2.13333rem"
  },
  "landmark-detail-modal__header-content": {
    "marginLeft": "0.24rem",
    "flexDirection": "column",
    "justifyContent": "flex-start",
    "alignItems": "flex-start",
    "height": "2.34667rem",
    "width": "7.06667rem"
  },
  "landmark-detail-modal__header-title-text": {
    "maxWidth": "7.06667rem",
    "fontFamily": "PingFang SC",
    "fontSize": "0.37333rem",
    "fontWeight": "600",
    "color": "rgb(17,17,17)"
  },
  "landmark-detail-modal__header-desc-text": {
    "maxWidth": "7.06667rem",
    "marginTop": "0.06667rem",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "fontWeight": "normal"
  }
};



  module.exports = _styles;
  